module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/anniversary_celebration_card.png";